import SearchBox from "../../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../../common_nextgen/common_components/Modal/ConfirmationModal";
import useGpiScreen from "./hooks/useGpiScreen";

const GpiScreen = ({
  setScreenType,
  selectParams,
  hideModal,
  lookupType,
  selectMode,
  onSelect,
  selectParamsData,
  screenTitle,
  screenNumber,
  multiSelect
}) => {
  const gpiScreenData = useGpiScreen(
    setScreenType,
    selectParams,
    hideModal,
    lookupType,
    selectMode,
    onSelect,
    selectParamsData,
    screenTitle,
    screenNumber,
    multiSelect
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection ctaButtons={gpiScreenData.leftButtons} align="left" />
      <div className="header-section">
        <h1>
          {gpiScreenData.screen_title} -{" "}
          <span className="heading-cod">{gpiScreenData.screenNumber}</span>
        </h1>
      </div>
      <SearchBox
        formFields={gpiScreenData.formFields}
        dropdownValues={gpiScreenData.dropdownValues}
        paramsData={gpiScreenData.paramsData}
        updataParamData={gpiScreenData.updateParamData}
      />
      <ButtonsSection ctaButtons={gpiScreenData.ctaButtons} />
      <DisplayTable
        data={gpiScreenData.data}
        parmKey={gpiScreenData.parmKey}
        menuOptions={gpiScreenData.menuOptions}
        tableHeaders={gpiScreenData.columnDef}
        setRowData={gpiScreenData.setRowData}
        selectedPriceSchedules={gpiScreenData.selectedRows}
        setSelectedPriceSchedules={gpiScreenData.setSelectedRows}
        selectMode={selectMode}
        multiSelect={multiSelect}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={gpiScreenData.first}
          rows={gpiScreenData.rows}
          totalRecords={gpiScreenData.totalRecords}
          currentPage={gpiScreenData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={gpiScreenData.onPageChange}
        />
      </div>
      {gpiScreenData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={gpiScreenData.isConfirmationModalOpen}
          onRequestClose={gpiScreenData.closeConfirmationModal}
          onBack={gpiScreenData.closeConfirmationModal}
          onSave={gpiScreenData.deleteGpi}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={gpiScreenData.setSelectedOption}
        />
      )}
    </div>
  );
};

export default GpiScreen;
